import React from 'react';
import Address from '../components/address';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const wrappedFunc = (func) => (prop, ...args) =>
  func(`loan${prop[0].toUpperCase()}${prop.substr(1)}`, ...args);

const textCreator = (occupanyType) => (occupanyType === 'SecondHome' ? 'secondary' : 'investment');

const AddressBuilder = ({ model, onChange, ...cardProps }) => (
  <Card
    title={`What's the address of your ${textCreator(model.get('occupancy'))} property?`}
    {...cardProps}
  >
    <Address
      model={{
        get: wrappedFunc(model.get.bind(model))
      }}
      onChange={wrappedFunc(onChange)}
      id="SecondaryInvestmentAddress"
      addressLabel="Address"
    />
  </Card>
);

AddressBuilder.completed = ({ model }) =>
  model.get('loanAddress') &&
  model.get('loanCity') &&
  model.get('loanState') &&
  model.get('loanZip');

AddressBuilder.id = 'City';

export const SecondaryInvestmentAddress = LoanCard(AddressBuilder);



// WEBPACK FOOTER //
// ./src/cards/secondary-investment-address.js